import {ChangeEvent, Dispatch, memo, SetStateAction, Suspense, useCallback, useEffect, useState} from 'react';
import {Modal} from "../Modal";
import {LoaderModal} from "../../../ui/loaderModal/LoaderModal";

import s from "./ReasonModal.module.css";
import {TextField} from "@mui/material";
import {CustomButton} from "../../../ui/Button/CustomButton";
import {useTranslation} from "react-i18next";


interface InformationModalProps {
    isOpen: boolean
    onClose?: () => void
    isMoreZIndex?: boolean
    reasonForComplaint: string;
    setReasonForComplaint: Dispatch<SetStateAction<string>>;
    onClickButton: Dispatch<SetStateAction<boolean>>;
    isSendReasonClicked: boolean;
    isSuccessSendingReason: boolean;
}

export const ReasonModal  = memo((props: InformationModalProps) => {
    const {
        isOpen,
        onClose,
        isMoreZIndex,
        reasonForComplaint,
        setReasonForComplaint,
        onClickButton,
        isSendReasonClicked,
        isSuccessSendingReason,
    } = props

    const {t} = useTranslation(['modal']);

    const [valueReasonModal, setValueReasonModal] = useState("");

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        setValueReasonModal(event.target.value);
    };

    useEffect(() => {
        if (isOpen) {
            setValueReasonModal("");
        }
    }, [isOpen]);

    return (
        <Modal
            isOpen={isOpen}
            lazy
            onClose={onClose}
            isMoreZIndex={isMoreZIndex}
            isCenter
            isCloseOnClick
        >
            <Suspense fallback={<LoaderModal/>}>
                <div className={s.reasonModal}>
                    <div style={{ marginBottom: 20, textAlign: "center", fontSize: 20 }}>
                        {t("modal:reason-modal.reason-complaint")}
                    </div>
                    <TextField
                        placeholder={t("modal:reason-modal.type-reason-complaint") || ""}
                        style={{ marginBottom: 30 }}
                        value={valueReasonModal}
                        onChange={handleChange}
                        variant="standard"
                        fullWidth
                        multiline
                    />
                    {isSuccessSendingReason && <span
                        style={{ marginBottom: 30, textAlign: 'center', fontSize: 14, color: "green" }}>
                        {t("modal:reason-modal.success")}
                    </span>}
                    <CustomButton onClick={() => {
                        setReasonForComplaint(valueReasonModal);
                        onClickButton(true);
                    }} disabled={!valueReasonModal || isSendReasonClicked}>
                        {t("modal:reason-modal.button-complain")}
                    </CustomButton>
                </div>
            </Suspense>
        </Modal>
    );
});
